import Fallback from './SiteDashboardEdit.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./SiteDashboardEdit.page'),
});
